import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Navbar from "./components/sections/Navbar";
import Hero from "./components/sections/Hero";
import Stats from "./components/sections/Stats";
import HowItWorks from "./components/sections/HowItWorks";
import Features from "./components/sections/Features";
import Gallery from "./components/sections/Gallery";
import GetStarted from "./components/sections/GetStarted";
import MatchMoment from "./components/sections/MatchMoment";
import Testimonials from "./components/sections/Testimonials";
import Interests from "./components/sections/Interests";
import Pricing from "./components/sections/Pricing";
import Trust from "./components/sections/Trust";
import FAQ from "./components/sections/FAQ";
import Download from "./components/sections/Download";
import Footer from "./components/sections/Footer";
import CursorTrail from "./components/ui/CursorTrail";
import ScrollToTop from "./components/ScrollToTop";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DeleteAccount from "./pages/DeleteAccount";
import PaymentLogin from "./pages/PaymentLogin";
import TermsOfUse from "./pages/TermsOfUse";
import Contact from "./pages/Contact";
import Support from "./pages/Support";
import SafetyCentre from "./pages/SafetyCentre";
import Account from "./pages/Account";
import Leads from "./pages/Leads";
import ChatExtension from "./pages/ChatExtension";
import MyChats from "./pages/ChatExtension/MyChats";

function LandingPage() {
  return (
    <main>
      <Hero />
      <Stats />
      <HowItWorks />
      <Features />
      <Gallery />
      <GetStarted />
      <MatchMoment />
      <Testimonials />
      <Interests />
      <Pricing />
      <Trust />
      <FAQ />
      <Download />
    </main>
  );
}

/**
 * Listens for the `auth:expired` event dispatched by authFetch when the
 * session can no longer be refreshed, and forces a redirect to the login
 * page. Uses `replace` so the user can't back-navigate into a broken state.
 */
function SessionExpiryGuard() {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => {
      // Preserve the current path so the login page can bounce back
      const returnTo = window.location.pathname + window.location.search;
      const params = new URLSearchParams();
      if (returnTo && returnTo !== "/pay") params.set("returnTo", returnTo);
      const query = params.toString();
      navigate(`/pay${query ? `?${query}` : ""}`, { replace: true });
    };
    window.addEventListener("auth:expired", handler);
    return () => window.removeEventListener("auth:expired", handler);
  }, [navigate]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <CursorTrail />
      <SessionExpiryGuard />
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/support" element={<Support />} />
        <Route path="/safety" element={<SafetyCentre />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/account" element={<Account />} />
        <Route path="/pay" element={<PaymentLogin />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/extend/:matchId" element={<ChatExtension />} />
        <Route path="/my-chats" element={<MyChats />} />
        <Route path="/extend/:matchId" element={<ChatExtension />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
